import { z } from "zod";

export const mediaSchema = z.object({
	id: z.number(),
	model_type: z.string(),
	model_id: z.string().uuid(),
	uuid: z.string().uuid(),
	collection_name: z.string(),
	name: z.string(),
	file_name: z.string(),
	mime_type: z.string(),
	disk: z.string(),
	conversions_disk: z.string(),
	created_at: z.string().datetime(),
	updated_at: z.string().datetime(),
	custom_properties: z.array(z.unknown()),
	generated_conversions: z.array(z.unknown()),
	manipulations: z.array(z.unknown()),
	order_column: z.number(),
	original_url: z.string().url(),
	preview_url: z.string(),
	responsive_images: z.array(z.unknown()),
	size: z.number(),
});

export type Media = z.infer<typeof mediaSchema>;
